/**
 * Update notification documents (arbitium_notifications).
 * Blueprint: arbitium_notifications.json — status: unread | read | dismissed.
 */

import { putRingDoc } from '../core';

const RING_NOTIFICATIONS = 'arbitium_notifications';

/**
 * Updates a notification's status (partial update).
 */
export async function updateNotificationStatus(
  notificationId: string,
  status: 'read' | 'dismissed'
): Promise<boolean> {
  const res = await putRingDoc(RING_NOTIFICATIONS, notificationId, { status });
  return res.success;
}
